import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@material-ui/styles/makeStyles';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Container from '@material-ui/core/Container';


import {Footer} from './components';
import SidebarPro, { SIDEBAR_WIDTH_EXPANDED, SIDEBAR_WIDTH_COLLAPSED } from './components/SidebarPro';
import { useGlobalState } from '../../state';
import Chip from "@material-ui/core/Chip";
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { GetStarted } from '../../components/GetStarted';

const useStyles = makeStyles(theme => ({
    root: {

        height: '100%',
        [theme.breakpoints.down('sm')]: {
            //paddingTop: 56
        }

    },
    shiftContent: {
        paddingLeft: 240
    },
    content: {
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
        padding:'0px',
        // backgroundImage:"url('/images/poultry-back.png')",
        position: 'relative',
        backgroundColor: '#fbf9fa',
    },
    divMask: {
        // background:theme.palette.backgroundOpacityColor,
        minHeight: '100vh'
    },
    body: {
        flex: 1,
        padding: '0',
        minHeight: '90vh',
        // '& > div': {
        //     margin: 0,
        // },
    },
    messageContainer:{

            margin: theme.spacing(0),
            position: 'absolute',
            top: '12px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'none',

    }
}));

const Main = props => {
    const {children} = props;
    const [errorText,setErrorText] = useState(undefined);
    const [messageText,setMessageText] = useState(undefined);
    const [{ sidebarCollapsed }] = useGlobalState();

    const classes = useStyles({});
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
        defaultMatches: true
    });

    const onErrorChipClose=()=>{
        setErrorText('');
    }

    const onMessageChipClose=()=>{
        setMessageText('');
    }

    const desktopPadding = isDesktop
        ? (sidebarCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED)
        : 0;

    return (

        <div
            className={clsx({
                [classes.root]: true,
            })}
            style={isDesktop ? { paddingLeft: desktopPadding, transition: 'padding-left 0.3s ease' } : undefined}
        >
            <SidebarPro />
            <main className={classes.content}>
                <GetStarted/>
                <div className={classes.divMask}>
                <Container maxWidth='xl' className={classes.body}>
                    <div className={classes.messageContainer}>
                        {
                            errorText ?
                                <Chip size="small" color="secondary" icon={<ErrorIcon/>} label={errorText} onDelete={onErrorChipClose}/> :
                                undefined
                        }
                        {
                            messageText ?
                                <Chip color="primary" icon={<CheckCircleIcon/>} onDelete={onMessageChipClose}
                                      label={messageText}/> :
                                undefined
                        }
                    </div>
                    {React.cloneElement(children, { showError: setErrorText,showMessage:setMessageText })}
                </Container>
                <Footer/>
                </div>
            </main>
        </div>
    );
};

Main.propTypes = {
    children: PropTypes.node
};

export default Main;
